import { ButtonIcon } from '@delmonicos/shared-design-system-react/src/components/button-icon/button-icon';
import {
  Dialog,
  DialogSize,
} from '@delmonicos/shared-design-system-react/src/components/dialog/dialog';
import { hasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';
import { TicketCreateController } from '@app/feature/ticket/ticket-create/ticket-create.controller';
import { useSetPageActionContext } from '@shared/layout/page-layout/page-layout-action.context-provider';

import { TicketListView, TicketTabKey } from './ticket-list.view';

export const TicketListController = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const navigate = useNavigate();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  const userPermissions = useAppSelector(permissions);

  // ACTIONS ///////////////////////////////////////////////////////////////////

  const [actionCreateIsDialogOpen, setActionCreateIsDialogOpen] =
    useState(false);
  const [activeTab, setActiveTab] = useState<TicketTabKey>(TicketTabKey.Todo);

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do — each section manages its own query

  // PAGE TITLE ////////////////////////////////////////////////////////////////

  // Nothing to do

  // PAGE ACTIONS //////////////////////////////////////////////////////////////

  const setPageAction = useSetPageActionContext();

  useEffect(() => {
    if (
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.TICKETS,
        action: ActionsByResource.TICKETS.CREATE,
      })
    ) {
      setPageAction([
        <ButtonIcon
          key="create"
          icon="plus"
          onClick={() => setActionCreateIsDialogOpen(true)}
        />,
      ]);
    }
  }, [setPageAction, userPermissions]);

  // PAGE BREADCRUMB ///////////////////////////////////////////////////////////

  // Nothing to do

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleActionRead = (id: string) => {
    navigate(generatePath(APP_PATH.TICKET.DETAILS, { id }));
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <TicketListView
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onActionRead={handleActionRead}
      />
      <Dialog
        open={actionCreateIsDialogOpen}
        onClose={() => setActionCreateIsDialogOpen(false)}
        confirmClose
        height="100%"
        size={DialogSize.LARGE}>
        <Dialog.Header
          icon="clipboard"
          onClose={() => setActionCreateIsDialogOpen(false)}
          title={t('$.ticket-create.title')}
        />
        <Dialog.Content>
          <TicketCreateController
            onCancel={() => setActionCreateIsDialogOpen(false)}
            onSuccess={() => setActionCreateIsDialogOpen(false)}
          />
        </Dialog.Content>
      </Dialog>
    </>
  );
};
